import { InsurancePolicyProviderType } from '@/shared/enums';
import { atomFamily } from 'jotai-family';
import { atomWithQuery } from 'jotai-tanstack-query';
import { fetchInsurancePolicyProviderDetails } from '../api/fetchInsurancePolicyProviderDetails';
import { InsurancePolicyProviderDetailsDto } from '../types/InsurancePolicyProviderDetailsDto';

const INSURANCE_POLICY_PROVIDER_DETAILS_KEY =
    'INSURANCE_POLICY_PROVIDER_DETAILS_KEY';

export const insurancePolicyProviderDetailsQueryAtom = atomFamily(
    (insurancePolicyProviderType: InsurancePolicyProviderType) =>
        atomWithQuery<InsurancePolicyProviderDetailsDto>(() => {
            return {
                queryKey: [
                    INSURANCE_POLICY_PROVIDER_DETAILS_KEY,
                    insurancePolicyProviderType,
                ],
                queryFn: () =>
                    fetchInsurancePolicyProviderDetails({
                        insurancePolicyProviderType,
                    }),
            };
        }),
);
